import { render, staticRenderFns } from "./TimeslotDropPlaceholder.vue?vue&type=template&id=535581cb&scoped=true&lang=pug&"
import script from "./TimeslotDropPlaceholder.vue?vue&type=script&lang=js&"
export * from "./TimeslotDropPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./TimeslotDropPlaceholder.vue?vue&type=style&index=0&id=535581cb&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535581cb",
  null
  
)

export default component.exports